export class MathExtension {
  static Clamp(number, min, max) {
    return Math.min(Math.max(min, number), max);
  }
}
